import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert, MDBSelect, MDBTable, MDBTableBody, MDBTableHead,   } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption, } from "mdbreact";
import Axios from 'axios'
import { URL,api } from '../../api';
import Swal from 'sweetalert2'
import { Select } from 'antd';
import Modalarticleaddexpertdelete from './Modalarticleaddexpertdelete';


export default class Modalarticleaddexpert extends Component {
    constructor(props) {
        super(props);
this.state = {
  modal: false,

   inside:"",
   faculty:"",
   Expert:[],
   idExpert:"",
   id_send:"",
   send_uploadeword1:"",
   send_uploadepdf1:"",
   Expertmaparticle:[],
   expertbn_id:"",

   duplicate : false, //ข้อมูลซ้ำ
}

this.handleChange = this.handleChange.bind(this);
//this.handleChange2 = this.handleChange2.bind(this);
this.handleSubmit = this.handleSubmit.bind(this);
this.getExpert = this.getExpert.bind(this);
this.getExpertmaparticle = this.getExpertmaparticle.bind(this);
}


toggle = () => {
  this.setState({
    modal: !this.state.modal
  });
 // this.props.selectat();
}


 componentDidMount() {
      const { id_send } = this.props.id_send
      console.log(id_send);
       this.setState({ id_send:this.props.id_send})
         this.setState({ expertbn_id:this.props.expert_id})
    //    this.setState({ send_uploadeword1:this.props.send_uploadeword1})
    //     this.setState({ send_uploadepdf1:this.props.send_uploadepdf1})
      setTimeout(() => {
        api.get('registercon/selectexpertforadmintype')
        .then(res => {
          console.log(res);
          const select = res.data.map((i) => ({
            value: i.id_expert,
            label: i.name_expert+' (เชียวชาญ '+i.expertise_expert+')',
          }));
          this.setState({ Expert: select})
        }) 
      }, 400);

      this.getExpertmaparticle()
  }

  getExpert() {
    setTimeout(() => {
      //ภายใน
      api.get('registercon/selectexpertenforadmintype')
      .then(res => {
        console.log(res);
      //  this.setState({ bankname: res.data, loading: false })
        this.setState({ Expert: res.data})
      }) 

    }, 400);

}

getExpertmaparticle() {
    setTimeout(() => {
      //ภายใน
      api.get('registercon/selectexpertforarticle/'+this.props.id_send)
      .then(res => {
        console.log(res);
      //  this.setState({ bankname: res.data, loading: false })
        this.setState({ Expertmaparticle: res.data})
      }) 

    }, 400);

}





  handleChange(event) { 
console.log(this.state.id_send)

const result = this.state.Expertmaparticle.filter(word => word.id_sendarticle === this.state.id_send && word.id_expert === event);
console.log(result)
if (result.length > 0) {
    this.setState({duplicate: true}); 
    Swal.fire({
        title: 'คุณเลือกผู้ทรงคุณวุฒิซ้ำ',
        text: "กรุณาเลือกผู้ทรงคุณวุฒิใหม่อีกครั้ง",
        icon: 'question',
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ตกลง'
    }).then((result) => {
        if (result.isConfirmed) {
        // Swal.fire(
        //   'Deleted!',
        //   'Your file has been deleted.',
        //   'success'
        // )
      //  this.props.updateat();
       // this.toggle()
        }
    })
}else{
    this.setState({idExpert: event}); 
    this.setState({duplicate: false}); 
}

       
     }
 // handleChange2(event) {    this.setState({faculty: event.target.value});  }

  handleSubmit() {
    // alert('A name was submitted: ' + this.state.value);

                    setTimeout(() => {

                       // event.preventDefault();
                        const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
                         datafrm.append("idExpert", this.state.idExpert);
                         datafrm.append("idsend", this.state.id_send);
                         datafrm.append("id_expertbn", this.state.expertbn_id);

                        api.post("registercon/Insertexpertexmaparticle",datafrm,{
                            headers: {
                                'content-type': 'multipart/form-data'
                            }
                           })
                        .then(res => {
                        console.log("response: ", res)
                        if (res.data.length !== 0) {
                        // this.showitem = true;
                                        console.log(res)
                                        console.log(res.data.length) 
                                        Swal.fire({
                                            title: 'เพิ่มผู้ทรงคุณวุฒิสำเร็จ',
                                            text: "Successfully added editor",
                                            icon: 'success',
                                            showCancelButton: false,
                                            confirmButtonColor: '#3085d6',
                                            cancelButtonColor: '#d33',
                                            confirmButtonText: 'ตกลง'
                                        }).then((result) => {
                                            if (result.isConfirmed) {
                                            // Swal.fire(
                                            //   'Deleted!',
                                            //   'Your file has been deleted.',
                                            //   'success'
                                            // )
                                            this.getExpertmaparticle();
                                            this.toggle()
                                            }
                                        })
                        }else{
                        // window.location.href = '/'
                        }
                    })

                    }, 500);
                
  }

  

    render() {
       console.log(this.state.expertbn_id)
    //    console.log(this.state.id_send)
        return (
            <MDBContainer>
            <MDBBtn color="secondary" size='sm' onClick={this.toggle}>เลือกผู้ทรงคุณวุฒิ</MDBBtn>


            <MDBTable bordered responsive small>
                    <MDBTableHead color="blue-grey lighten-3" textWhite>
                        <tr>
                        <th>ลำดับ</th>
                        <th>ชื่อผู้ทรงคุณวุฒิ</th>
                        <th>สังกัด</th>
                        {/* <th>ไฟล์บทความต้นฉบับ</th> */}
                        <th>ความเชียวชาญ</th>
                        <th>เบอร์โทร</th>
                        <th>จัดการ</th>
                        </tr>
                    </MDBTableHead>

                    <MDBTableBody>
                    {this.state.Expertmaparticle.map((Expertmaparticle,index )  => 
                        <tr>
                        <td>{index+1}</td>
                        <td>{Expertmaparticle.name_expert}</td>
                        <td>{Expertmaparticle.affiliation_expert}</td>
                        <td>{Expertmaparticle.expertise_expert}</td>
                        <td>{Expertmaparticle.tel_expert}</td>
                        <td>
                          {this.props.bn_comment ==='2'?<>  <MDBBtn color="danger" size='sm' disabled>ลบ</MDBBtn></>:<>  <Modalarticleaddexpertdelete id_send={this.state.id_send} id_expert={Expertmaparticle.id_expert} getExpertmaparticle={this.getExpertmaparticle} /></>}
                        </td>
                         
                        </tr>
                      )}
                    </MDBTableBody>
                    </MDBTable>


            <MDBModal isOpen={this.state.modal} toggle={this.toggle}>
              <MDBModalHeader toggle={this.toggle}>ชื่อบทความ {this.props.name_article} </MDBModalHeader>
              <MDBModalBody>
              <div>
              
        <p>เลือกผู้ทรงคุณวุฒิ</p>
        {/* <select className="browser-default custom-select" onChange={this.handleChange}>
                   <option>------กรุณาเลือกผู้ทรงคุณวุฒิ------</option>
                   {this.state.Expert.map((Expert,index )  => 
                   <option value={Expert.id_expertbn}>{Expert.name_expertbn}</option>
                   )}
        </select> */}
         <Select
         onChange={this.handleChange}
    showSearch
    style={{ width: '100%' }}
    placeholder="เลือกผู้ทรงสำหรับอ่านบทความ"
    optionFilterProp="label"
    filterSort={(optionA, optionB) =>
      (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
    }
    options={this.state.Expert}
  />
        
              </div>
              </MDBModalBody>
              <MDBModalFooter>
                {this.state.duplicate === true ?<>
                    <MDBBtn color="primary" disabled >บันทึก</MDBBtn>
                </>:<>
                <MDBBtn color="primary" onClick={this.handleSubmit} >บันทึก</MDBBtn>
                </>}
                
                <MDBBtn color="secondary" onClick={this.toggle}>ปิด</MDBBtn>
                
              </MDBModalFooter>
            </MDBModal>
          </MDBContainer>
        )
    }
}
